import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { profilePage } from '@pages/ProfilePage';
import { AnalyticsScreenNames } from '@src/app/utils/analyticsScreenNames';
import { loadAsyncWithLoadingState } from '@src/app/utils/loadAsyncComponent';

export const notificationsRoutes: SuperbetRouteConfig[] = [
    {
        path: Link.BonusAndComms.Notifications,
        name: RouteName.BonusAndComms.Notifications,
        components: {
            ...profilePage,
            subnav: loadAsyncWithLoadingState<unknown>(() => import('@src/app/modules/userProfile/notifications/NotificationsPageHeader.vue')),
            mobileSubnav: loadAsyncWithLoadingState<unknown>(() => import('@src/app/modules/userProfile/notifications/NotificationsPageHeader.vue')),
            content: () => import('@modules/userProfile/notifications/NotificationsContainer.vue'),
        },
        meta: {
            title: Title.BonusAndComms.Notifications,
            layoutClass: 'notifications-page',
            superAnalytics: {
                pageName: AnalyticsScreenNames.notifications,
            },
            headerTitle: 'pam.accountMenu.notifications',
        },
    },
];
